/*
 *  I02COSTENERCalcul.js
 *
 *  Created by Sébastien Hecart on 2018-10-27 14:12:13 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchRendementProductionAll } from '@batical/data/src'
import { RRendementProductionSchema_Type, I02COSTENER_State } from '@batical/types/src'

function I02COSTENER_docalcul(state: I02COSTENER_State, _isWeb = false) {
  const rendProdList = fetchRendementProductionAll()

  let dataChart: Array<{
    x: string
    y: number
    fill: string
  }> = []

  let maxCost = 0
  if (state.in_consoAnnuelle > 0) {
    if (rendProdList) {
      for (let index = 0; index < rendProdList.length; index++) {
        const value: RRendementProductionSchema_Type = rendProdList[index]
        const temp = (value.prix * state.in_consoAnnuelle) / value.rendementProduction
        if (!isNaN(temp)) {
          maxCost = Math.max(maxCost, Math.trunc(temp))

          dataChart.push({ x: String(value.name), y: Math.trunc(temp), fill: value.color })
        }
      }
    }
    dataChart.sort((a, b) => a.y - b.y)
  }

  state.maxCost = maxCost

  state.dataChart = dataChart

  state.invalidated = false
  return state
}

export default I02COSTENER_docalcul
